import { Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { IconCircleX } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { forwardRef, useEffect, useState, } from "react";
import { connect } from "react-redux";
import { setReportFilteredData } from "store/app/report-management/report-generations/actions";
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import VWDropdown from "components/dropdown";
import {
    getDistrictOption,
    getLocationOption,
    getRegionOption,
    getStateOption
} from "store/app/farm-management/farm-records/actions";
import { unionBy } from 'lodash';

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterReportGeneration = (props) => {

    const { open, onClose, reportFilterData } = props;
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (reportFilterData) {
            setFilter(reportFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);
    //--------------------Location------------------------------------
    const [locationOptions, setLocationOptions] = useState([]);
    const loadLocationOption = (filter) => {
        return props.getLocationOption(filter, filter?.recordstatus)
    }

    //--------------------Region--------------------------------------
    const [regionOptions, setRegionOptions] = useState([]);
    const loadRegionOptions = (filter, page, pageSize) => {
        return props.getRegionOption(filter, "filter", page, pageSize)
    }

    //--------------------State---------------------------------------
    const [stateOptions, setStateOptions] = useState([]);
    const loadStateOption = (state, page, pageSize) => {
        return props.getStateOption(state, filter?.region, page, pageSize)
    }

    //--------------------District------------------------------------
    const [districtOptions, setDistrictOptions] = useState([]);
    const loadDistrictOption = (district, page, pageSize) => {
        return props.getDistrictOption(district, filter?.state, filter?.region, page, pageSize)
    }

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        if ((name === "examinedbirdscount" || name === "totalnoofbirdsplaced") && Number(value) > 10000000) {
            return;
        }
        setFilter({
            ...filter,
            [name]: value,
        });
    }

    const validateOnDate = (date) => {
        const formattedDate = date ? moment(date).format("DD-MM-YYYY") : null;
        setFilter({
            ...filter,
            inspectiondate: formattedDate,
        });
    }

    const handleSelect = (option, name) => {
        const optionArray = option?.map((field) => field.label ? field.label : field);
        const optionString = optionArray?.length > 0 ? optionArray.join() : null;
        if (name === "region") {
            setFilter({
                ...filter,
                [name]: optionString,
                state: null,
                district: null,
            });
            setStateOptions([]);
            setDistrictOptions([]);
        }
        else if (name === "state") {
            setFilter({
                ...filter,
                [name]: optionString,
                district: null,
            });
            setDistrictOptions([]);
        }
        else {
            setFilter({
                ...filter,
                [name]: optionString,
            });
        }
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        props.setReportFilteredData(nonEmptyData);
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setReportFilteredData();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={4} columnGap={1} direction="column"  >
                                            <Grid item>
                                                <TextField
                                                    autoFocus
                                                    label="Farm Name"
                                                    fullWidth
                                                    size="small"
                                                    name='farmname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.farmname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    sx={styles}
                                                    label="Farm Record No."
                                                    fullWidth
                                                    size="small"
                                                    name='formrecordno'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={filter?.formrecordno}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label="Inspection Date"
                                                        onChange={validateOnDate}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={filter?.inspectiondate ? moment.utc(filter?.inspectiondate, "DD-MM-YYYY") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                            },
                                                            field: { clearable: true },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item>
                                                <VWDropdown
                                                    label="Location"
                                                    name="location"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadLocationOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.location ? filter.location.includes(",") ? filter.location.split(",") : [filter.location] : []}
                                                    options={locationOptions}
                                                    setOptions={setLocationOptions}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <VWDropdown
                                                    label="Region"
                                                    name="region"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadRegionOptions}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.region ? filter.region.includes(",") ? filter.region.split(",") : [filter.region] : []}
                                                    options={regionOptions}
                                                    setOptions={(options) => {
                                                        setRegionOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <VWDropdown
                                                    label="State/Export"
                                                    name="state"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadStateOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.state ? filter.state.includes(",") ? filter.state.split(",") : [filter.state] : []}
                                                    options={stateOptions}
                                                    setOptions={(options) => {
                                                        setStateOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <VWDropdown
                                                    label="District"
                                                    name="district"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadDistrictOption}
                                                    onSelect={handleSelect}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.district ? filter.district.includes(",") ? filter.district.split(",") : [filter.district] : []}
                                                    options={districtOptions}
                                                    setOptions={(options) => {
                                                        setDistrictOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Examined Birds Count"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='examinedbirdscount'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={filter?.examinedbirdscount}
                                                    inputProps={{ max: 10000000 }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Total No Of Birds Placed"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='totalnoofbirdsplaced'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={filter?.totalnoofbirdsplaced}
                                                    inputProps={{ max: 10000000 }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ mt: 2, mb: 2 }}
                                                >
                                                    Note: Counts can only be entered up to <b>1,00,00,000</b>.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )}
            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    reportFilterData: state.reportGeneration.reportFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setReportFilteredData: (filter) => dispatch(setReportFilteredData(filter)),
    //--------------------Location------------------------------------
    getLocationOption: (filter) => dispatch(getLocationOption(filter)),
    //--------------------Region--------------------------------------
    getRegionOption: (filter, type, page, pageSize) => dispatch(getRegionOption(filter, type, page, pageSize)),
    //--------------------State---------------------------------------
    getStateOption: (filter, region, page, pageSize) => dispatch(getStateOption(filter, region, page, pageSize)),
    //--------------------District------------------------------------
    getDistrictOption: (filter, state, region, page, pageSize) => dispatch(getDistrictOption(filter, state, region, page, pageSize)),


})

export default connect(mapStateToProps, mapDispatchToProps)(FilterReportGeneration);